import { render, staticRenderFns } from "./BoothAdvertising.vue?vue&type=template&id=181f6aa8&scoped=true"
import script from "./BoothAdvertising.vue?vue&type=script&lang=js"
export * from "./BoothAdvertising.vue?vue&type=script&lang=js"
import style0 from "./BoothAdvertising.vue?vue&type=style&index=0&id=181f6aa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f6aa8",
  null
  
)

export default component.exports